import React from "react";
import Namespace from 'src/constants/locale/Namespace'
import ReactivateUserKeys from '../../../constants/locale/key/ReactivateUser'
import { components, useTranslation } from 'cng-web-lib'

const {
  button: { CngButton }
} = components

function ReactivateUserButtonComponent({
  onSubmit,
}) {

  const { translate } = useTranslation(Namespace.REACTIVATE_USER)
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {

    let submitButton = translate(
      Namespace.REACTIVATE_USER,
      ReactivateUserKeys.SUBMIT_BUTTON
    )
    return {
      submitButton
    }
  }

  return (
    <CngButton onClick={onSubmit}>
      {translatedTextsObject.submitButton}
    </CngButton>
  );
}

export default ReactivateUserButtonComponent;
